import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createItem,
  fetchAllItems,
  updateItem,
  fetchOneItem,
  deleteItem,
} from "services/item";

// Fetch all items with optional filtering
export const useAllItems = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["items", filters],
    queryFn: () => fetchAllItems(filters),
    enabled,
  });
};

// Fetch single item by ID
export const useOneItem = (id, enabled = true) => {
  return useQuery({
    queryKey: ["item", id],
    queryFn: () => fetchOneItem(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new item
export const useCreateItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["items"] });
    },
  });
};

// Update existing item
export const useUpdateItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateItem(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["items"] });
      queryClient.invalidateQueries({ queryKey: ["item", variables.id] });
    },
  });
};

// Delete item
export const useDeleteItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteItem(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["items"] });
      queryClient.invalidateQueries({ queryKey: ["item", id] });
    },
  });
};
